import { RouterProvider } from 'react-router-dom';
import type { Router } from './router/router.tsx';

export default function App({ router }: { router: Router }) {
  return <RouterProvider router={router} />;
}
